<div class="flex flex-col items-center justify-center min-h-[calc(100vh_-_52px)] bg-gray-100 px-4">
  <div class="flex items-center justify-center w-28 h-28 rounded-full bg-red-100 shadow-md">
    <i class="icon-wl-report text-red-600 text-[56px]"></i>
  </div>

  <h2 class="mt-4 text-2xl font-semibold text-gray-800 text-center max-w-xl leading-relaxed">
    {{ 'COMMON.NO_PERMISSION_NOTE' | translate }}
  </h2>
</div>
